class VigenciaVelocidadeRegulamentada {
    constructor(
        {
            id = null,
            vigencia_localizacao_equipamento_id = null,
            data_inicio_vigencia = null,
            velocidade_regulamentada = null,
            created_at = null,
            updated_at = null,
            deleted_at = null,
            usuario_id = null,
        } = {}
    ) {
        this.id = id;
        this.vigencia_localizacao_equipamento_id = vigencia_localizacao_equipamento_id;
        this.data_inicio_vigencia = data_inicio_vigencia;
        this.velocidade_regulamentada = velocidade_regulamentada ? parseFloat(velocidade_regulamentada) : null;
        this.created_at = created_at;
        this.updated_at = updated_at;
        this.deleted_at = deleted_at;
        this.usuario_id = usuario_id;
    }
}

export default VigenciaVelocidadeRegulamentada;